import { Link } from "react-router-dom";

export default function MobileBottomCTA({ price, label = "Prenota" }) {
  return (
    <div data-testid="mobile-bottom-cta" className="lg:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-cream-200">
      <div className="px-5 py-3 flex items-center justify-between gap-3">
        <div>
          {price ? (
            <>
              <p className="text-base font-semibold text-slate-900">€ {price}<span className="text-sm font-normal text-slate-600"> / notte</span></p>
              <p className="text-[11px] text-slate-600">tasse e costi inclusi</p>
            </>
          ) : (
            <p className="text-sm text-slate-900">Pronto per il tuo soggiorno?</p>
          )}
        </div>
        <Link
          to="/prenotazione"
          data-testid="mobile-cta-prenota"
          className="rounded-full bg-navy-600 hover:bg-navy-700 text-white text-sm font-medium px-6 py-3 transition-colors"
        >
          {label}
        </Link>
      </div>
    </div>
  );
}
